





















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import {
  FormatReference,
} from "../../../domain/format";
import { ModelEditableMixin } from "../../system/mixins";
import CustomListBoxSelector from "../../system/selectors/CustomListBoxSelector.vue";
import { DeveloperPresentableMixin } from "../../developer/mixins";

@Component({
  components: {
    CustomListBoxSelector,
  }
})
export default class FormatReferencesListBoxSelector extends Mixins(ModelEditableMixin, DeveloperPresentableMixin) {
  @Prop({ default: () => [] as FormatReference[] })
  values: FormatReference[];

  @Prop({ default: () => ({}) })
  hashTableDirectoryPathForEachFormat: { [key: number]: string };

  @Prop({ default: null })
  formatId: number;

  data(): any {
    return {
      defaultSelectFormat: !!this.formatId,
    };
  }
  defaultSelectFormat: boolean;

  get options(): FormatReference[] {
    const results = this.values.slice();  // 複製して処理する
    if (!!this.formatId) {
      // infinite-loading対応で見えてないフォーマットIDだと選択できない.先頭に持ってくる.
      this.$logger.debug("フォーマットIDが指定されてるので当該フォーマットは先頭に移す.: " + this.formatId);
      // findIndexはIE非対応らしいのでループで探す.
      for (let i = 0; i < results.length; i++) {
        if (results[i].id.toString() === this.formatId.toString()) {
          this.$logger.debug("指定されたフォーマットが見つかりました.: " + results[i].name);
          const popped = results[i];
          results.splice(i, 1);
          results.unshift(popped);
          break;
        }
      }
    }
    return results;
  }

  private containsDefaultFormat(value: FormatReference): boolean {
    // numberを===した場合falseになる(==は出来るがtslにワーニング指摘される)のでとりあえず文字列で
    const ret = this.defaultSelectFormat
      ? (value.id.toString() === this.formatId.toString())
      : false; 
    if (ret) {
      // このメソッドの呼び元は選択項目の表示のための評価を契機としているので、infinite-loadingにより表示されない項目には適用できない。
      // そもそもここで選択を反映しているのがおかしいように見える。要注意。
      this.defaultSelectFormat = false;
      this.editingSource = value;
    }
    return ret;
  }

  private hasHashTableDirectoryPathForEachFormat(row: FormatReference): boolean {
    return !!this.hashTableDirectoryPathForEachFormat[row.id];
  }

  private shouldShowDirectoryPath(row: FormatReference): boolean {
    return this.$configuration.behavior.format.selector.shouldShowDirectoryPath && this.hasHashTableDirectoryPathForEachFormat(row);
  }

  equivalentValidator(source: FormatReference, destination: FormatReference): boolean {
    return (source === destination) ||
      (source && destination && (source.id === destination.id));
  }

  toRowClass(row: FormatReference): string {
    return this.shouldShowDirectoryPath(row)
      ? "multiple-line"
      : "single-line";
  }

  toLabelClass(row: FormatReference): string {
    this.containsDefaultFormat(row);
    return row.expired || row.deleted
      ? "invalid"
      : "";
  }

  toLabel(row: FormatReference): string {
    return this.isDeveloperMode
      ? "【" + row.id + "】" + row.name
      : row.name;
  }

  toDirector(row: FormatReference): string {
    return this.shouldShowDirectoryPath(row)
      ? this.hashTableDirectoryPathForEachFormat[row.id]
      : "";
  }

  hasFormatNote(row: FormatReference): boolean {
    return !!row.note;
  }

  toFormatNotes(row: FormatReference): string[] {
    const note = row.note.replace(/\\r/g, "\r").replace(/\\n/g, "\n");
    return note.split("\n");
  }

  @Emit("formatDoubleClicked")
  formatDoubleClicked(): void {}
}
